import styled, { css } from 'styled-components';

interface ContainerProps {
  isError: boolean;
}

export const Container = styled.div<ContainerProps>`
  > input {
    ${props =>
      props.isError &&
      css`
        border-color: red;
      `}
  }
`;

export const Error = styled.div`
  display: block;
`;
